import api from ".";
import { getToken } from "../Auth/Token";

const getAuthConfig = () => {
  const token = getToken();
  if (!token) {
    throw new Error("Authentication token is missing");
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getAllTrademarks = async () => {
  try {
    const { data } = await api.get("api/trademarks", getAuthConfig());

    return data?.data ?? [];
  } catch (error) {
    console.error("getAllTrademarks failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      code: error.code,
    });

    throw {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch trademarks. Please try again.",
      status: error.response?.status,
      error, 
    };
  }
};

export const createTrademark = async (nameOrData, maybePrefix) => {
  let name = "";
  let customPrefix = maybePrefix;
  if (typeof nameOrData === "object" && nameOrData !== null) {
    name = nameOrData.name;
    customPrefix = nameOrData.customPrefix;
  } else {
    name = nameOrData;
  }

  if (!name?.trim()) {
    throw new Error("Trademark name is required and cannot be empty");
  }

  const trimmedName = name.trim();
  const trimmedPrefix = customPrefix ? String(customPrefix).trim() : undefined;

  try {
    const { data } = await api.post(
      "/api/trademarks",
      { name: trimmedName, customPrefix: trimmedPrefix },
      getAuthConfig()
    );

    return data?.data ?? null;
  } catch (error) {
    console.error("createTrademark failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      name: trimmedName,
    });

    throw {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to create trademark. Please try again.",
      status: error.response?.status,
      error,
    };
  }
};

export const updateTrademark = async (id, payload) => {
  if (!id) throw new Error("Trademark ID is required");

  try {
    const { data } = await api.put(
      `/api/trademarks/${id}`,
      payload,
      getAuthConfig()
    );

    return data?.data ?? null;
  } catch (error) {
    console.error("updateTrademark failed:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to update trademark.",
      error,
    };
  }
};

export const deleteTrademark = async (id) => {
  if (!id) throw new Error("Trademark ID is required");

  try {
    const { data } = await api.delete(`/api/trademarks/${id}`, getAuthConfig());
    return data;
  } catch (error) {
    console.error("deleteTrademark failed:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to delete trademark.",
      error,
    };
  }
};